import { render, staticRenderFns } from "./businessUnitPermissionTab.vue?vue&type=template&id=71aef514&scoped=true&"
import script from "./businessUnitPermissionTab.vue?vue&type=script&lang=js&"
export * from "./businessUnitPermissionTab.vue?vue&type=script&lang=js&"
import style0 from "./businessUnitPermissionTab.vue?vue&type=style&index=0&id=71aef514&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aef514",
  null
  
)

export default component.exports